const getContacts = (useCache = false) => {
  return new Promise((resolve, reject) => {
    if (window.userContacts && useCache) {
      resolve(window.userContacts)
      return
    }

    window.apiRequest('get', '/contacts/all')
      .then(r => {
        if (r.type === 'success') {
          window.userContacts = r.data
          resolve(r.data)
        } else {
          reject(r)
        }
      })
      .catch(reject)
  })
}

export default getContacts